import React, { useContext } from 'react'
import { Card, CardContent, Typography, Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../context/DailyMonitoringDetailsFiltersContext'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2)
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12pt',
      lineHeight: '24px',
      color: '#4B4B4B',
      marginBottom: theme.spacing(2)
    },
    highlight: {
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12pt',
      lineHeight: '28px',
      color: '#4B4B4B'
    },
    data: {
      display: 'flex',
      flexDirection: 'column'
    }
  })
)

type Props = {
  year?: number
  month?: number
  finalDate?: moment.Moment
}

function getBusinessDays ({ year, month, finalDate }: Props) {
  let weekendDays = 0
  for (let index = 1; index < (finalDate?.date() || moment(`${year}-${month}`, 'YYYY-MM').daysInMonth()); index++) {
    if (moment().date(index).get('day') === 6 || moment().date(index).get('day') === 0) {
      weekendDays++
    }
  }

  return finalDate ? finalDate.date() - weekendDays : moment(`${year}-${month}`, 'YYYY-MM').daysInMonth() - weekendDays
}

export default function Dateinfo (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const isActualDate = moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').isSame(moment(), 'M')

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography className={classes.title}>
          {`${moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').clone().startOf('month').format('DD/MM/YYYY')} à ${moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').clone().endOf('month').format('DD/MM/YYYY')}`}
        </Typography>
        <Grid item container spacing={1}>
          <Grid item xs={4} className={classes.data}>
            <Grid item xs={12}>Data atual</Grid>
            <Grid item xs={12} className={classes.highlight}>{moment().format('DD/MMM/YYYY')}</Grid>
          </Grid>
          <Grid item xs={4} className={classes.data}>
            <Grid item xs={12}>Dias corridos</Grid>
            <Grid item xs={12} className={classes.highlight}>{moment(`${filters.date.year}-${filters.date.month}`, 'YYYY-MM').daysInMonth()}</Grid>
          </Grid>
          <Grid item xs={4} className={classes.data}>
            <Grid item xs={12}>Dias úteis</Grid>
            <Grid item xs={12} className={classes.highlight}>
              {isActualDate
                ? `${getBusinessDays({ ...filters.date })} (até hoje ${getBusinessDays({ finalDate: moment().clone() })})`
                : `${getBusinessDays({ ...filters.date })}`
              }
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
